import { Typography } from 'antd'
import React from 'react'
const { Text } = Typography




const AELHandler = (props) => {
    const { unitToReturn, laserClass, condition, hec } = props

    const AEL = hec?.[`condition${condition}`]?.class?.[`class${laserClass}`]
    const AELval = AEL?.watts
    const CE = hec?.[`condition${condition}`]?.details?.collectedEmission
    const CEval = hec?.[`condition${condition}`]?.details?.collectedEmission?.watts


    return (
        <Text
            style= {props?.style}
            strong
            type={(() => {
                if (CEval <= AELval) return 'success'
                if (CEval >= AELval) return 'danger'
                return null
            })()}
        >
            {(() => {
                // AEL here
                if (unitToReturn === 'watts') {
                    return AEL?.aelStandard?.pretty || '-'
                } else {
                    return AEL?.aelStandard?.pretty || '-'
                }
            })()}
        </Text>
    )
}

export default AELHandler